/**
 * @author Brendan Magee
 * @desc Component for choosing multiple options from a list
 */

import template from './listSelectorDialog.html';

class ListSelectorDialogController {
  constructor() {
    const {
      displayProp = 'name',
      idProp = 'id',
      parentOption,
      searchOptions,
      searchPlaceholder,
      selectedOptions,
      submitText = 'APPLY_FILTER'
    } = this.resolve;

    // Option object keys
    this.displayProp = displayProp;
    this.idProp = idProp;

    // Search input placeholder
    this.placeholder = searchPlaceholder;
    // Submit button text
    this.submitText = submitText;

    this.parentOption = parentOption;
    this.selected = new Set(selectedOptions.map(option => option[this.idProp]));
    this.options = searchOptions;
  }

  toggle = (option) => {
    if (this.selected.has(option[this.idProp])) {
      this.selected.delete(option[this.idProp]);
    } else {
      this.selected.add(option[this.idProp]);
    }
  }

  selectParent = () => {
    this.selected.clear();
  };

  submit = () => {
    const selected = this.options.filter(opt => this.selected.has(opt[this.idProp]));

    this.modalInstance.close({
      parentOption: this.parentOption,
      selectedChildren: selected
    });
  }
}

const listSelectorDialog = {
  template,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  },
  controller: 'ListSelectorDialogController'
};

export default (ngModule) => {
  ngModule.component('listSelectorDialog', listSelectorDialog);
  ngModule.controller('ListSelectorDialogController', ListSelectorDialogController);
};
